'use strict';

import getNgModule from "getNgModule";
var ngModule = getNgModule(__filename);
ngModule.filter("ellipsis", function () {
  return function ellipsisFilter(value, maxLength) {
    if (!maxLength) {
      maxLength = 25; // longueur par défaut
    }
    if (value.length > maxLength) {
      value = value.substring(0, maxLength - 3) + "...";
    }
    return value;
  };
});


//////////////////
// WEBPACK FOOTER
// ./src/modules/common/ng/core/filters/ellipsis-filter.js
// module id = 2701
// module chunks = 13